import { Form, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import { AtendenteProps } from './props';
import { AxiosResponse } from 'axios';
import { UDNICK } from '../../service/udnick';
import Swal from 'sweetalert2';
import TextFilter from '../TextFilter';

const SelectAtendente: React.FC<AtendenteProps> = ({ setAtendente }) => {
  const { Option } = Select;

  const [response, setResponse] = useState([]);

  const onChange = (values: any) => {
    setAtendente(values);
    localStorage.setItem(`atendente${window.location.pathname}`, values);
  };

  const listaAtendentes = {
    getListaAtendentes: (): Promise<AxiosResponse> => UDNICK.callService('getListaAtendentes'),
  };

  useEffect(() => {
    try {
      listaAtendentes.getListaAtendentes().then((res) => {
        setResponse(res.data.listaAtendentes);
      });
    } catch (error) {
      Swal.fire({
        title: 'Não foi possivel carregar a lista de atendentes, por favor tente novamente!',
        html: '',
        icon: 'warning',
        showConfirmButton: false,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Form.Item label={<TextFilter>Atendente</TextFilter>} name="atendente">
        <Select
          onChange={onChange}
          style={{ width: '100%' }}
          showSearch
          optionFilterProp={'children'}
          filterOption={(input, option) =>
            option?.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {response.map((item: any) => (
            <Option value={item.codigo} key={item.codigo}>
              {item.descricao}
            </Option>
          ))}
        </Select>
      </Form.Item>
    </>
  );
};

export default SelectAtendente;
